import React, { useMemo } from 'react';
import { ColorRepresentation } from 'three';

import { LineSegment2D } from '@paragon/geometry-library';

import { convertFromLayoutToDesignCoordinates } from '../../library/layout-geometry/coordinates';
import { ManySegment } from './Segments';

interface EnvelopePlyDividersProps {
  segments: readonly LineSegment2D[];
  height: number;
  color: ColorRepresentation;
}

export function EnvelopePlyDividers({ segments, height, color }: EnvelopePlyDividersProps) {
  const threeDimensionalSegments = useMemo(
    () =>
      segments.map((segment) => {
        const start = convertFromLayoutToDesignCoordinates(segment.basePoint.to3D(height)).toArray();
        const end = convertFromLayoutToDesignCoordinates(segment.endPoint.to3D(height)).toArray();

        return { start, end, color };
      }),
    [segments, height, color],
  );

  return threeDimensionalSegments.length === 0 ? null : <ManySegment segments={threeDimensionalSegments} />;
}
